module.exports = __webpack_public_path__ + "static/media/dataverse.87fffb82.md";